import React from "react";
import "./WelcomeBanner.css";
import { BiChevronsRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const WelcomeBanner = ({ data }) => {
  WelcomeBanner.propTypes = {
    data: PropTypes.array.isRequired, // Replace `object` with the correct type
  };
  return (
    <div className="pattern-bg2">
      <div className="welcame-banner-bg container a-container">
        <div className="welcome-container ">
          {data.map((item) => {
            return (
              <div className="row " key={item}>
                <div className="col-md-5  justify-content-center align-items-center  welcome-banner-image">
                  <img className="welcome-img-12" src={item.img} alt="" />
                </div>
                <div className="col-md-7 d-flex align-items-center  welcome-banner-content ">
                  <div className="text-black w-full">
                    <small className=" title ">{item.heading}</small>
                    <br />
                    <h1 className=" heading !normal-case text-left ">
                      {item.subheading}
                    </h1>
                    <div className="w-service my-4">
                      <p className="paragraph ">
                        {/* <i class="fa-solid fa-angles-right me-2"></i> */}
                        <span>
                          {" "}
                          <BiChevronsRight
                            style={{ display: "inline" }}
                            className="text-primary"
                          />{" "}
                        </span>
                        {item.t1}
                      </p>
                      <p className="paragraph ">
                        {/* <i class="fa-solid fa-angles-right me-2"></i>  */}
                        <span>
                          {" "}
                          <BiChevronsRight
                            style={{ display: "inline" }}
                            className="text-primary"
                          />{" "}
                        </span>
                        {item.t2}
                      </p>
                      <p className="paragraph ">
                        {/* <i class="fa-solid fa-angles-right me-2"></i> */}
                        <span>
                          {" "}
                          <BiChevronsRight
                            style={{ display: "inline" }}
                            className="text-primary"
                          />{" "}
                        </span>
                        {item.t3}
                      </p>
                      <p className="paragraph ">
                        {/* <i class="fa-solid fa-angles-right me-2"></i>  */}
                        <span>
                          {" "}
                          <BiChevronsRight
                            style={{ display: "inline" }}
                            className="text-primary"
                          />{" "}
                        </span>
                        {item.t4}
                      </p>
                    </div>
                    <Link to="/marketplace-help">
                      <button className="!w-fit white-btn !border-[#fae441] !mb-[30px]">
                        {item.button}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
